import { Button, Space } from "antd";
import { setIcons ,getTimeFormat} from "@/utils/common";

import { deviceTypeOptions } from "@/utils/enums";
// import { useState } from "react";
// helps.tsx (1-230)
/**
 * 收益配置开关枚举（通用）
 * 0: 开启，1: 关闭
 */
export enum ProfitSwitchEnum {
  OPEN = 0, // 开启
  CLOSE = 1, // 关闭
}

/**
 * 收益提现配置项枚举（按业务类型分类）
 */
export enum ProfitWithdrawConfigEnum {
  // 佣金金额可提现
  AMOUNT_WITHDRAW = 'amountWithdrawOpen',
  // 渠道收益可提现
  CHANNEL_AMOUNT_WITHDRAW = 'channelAmountWithdrawOpen',
  // 充电收益可提现
  CHARGING_AMOUNT_WITHDRAW = 'chargingAmountWithdrawOpen',
  // 经销商销售收益可提现
  MERCHANT_AMOUNT_WITHDRAW = 'merchantAmountWithdrawOpen',
}

/**
 * 收益转赠配置项枚举（按业务类型分类）
 */
export enum ProfitTransferConfigEnum {
  // 佣金金额可转赠
  AMOUNT_TRANSFER = 'amountTransferOpen',
  // 渠道收益可转赠
  CHANNEL_AMOUNT_TRANSFER = 'channelAmountTransferOpen',
  // 充电收益可转赠
  CHARGING_AMOUNT_TRANSFER = 'chargingAmountTransferOpen',
  // 经销商销售收益可转赠
  MERCHANT_AMOUNT_TRANSFER = 'merchantAmountTransferOpen',
}

/**
 * 获取开关状态的文本描述（辅助函数）
 * @param status 开关值（0/1）
 * @returns 文本描述
 */
export const getProfitSwitchText = (status: number): string => {
  return status === ProfitSwitchEnum.OPEN ? '开启' : '关闭';
};

/**
 * 配置项名称映射（用于前端展示）
 */
export const ProfitConfigNameMap = {
  [ProfitWithdrawConfigEnum.AMOUNT_WITHDRAW]: '佣金金额可提现',
  [ProfitWithdrawConfigEnum.CHANNEL_AMOUNT_WITHDRAW]: '渠道收益可提现',
  [ProfitWithdrawConfigEnum.CHARGING_AMOUNT_WITHDRAW]: '充电收益可提现',
  [ProfitWithdrawConfigEnum.MERCHANT_AMOUNT_WITHDRAW]: '经销商销售收益可提现',
  [ProfitTransferConfigEnum.AMOUNT_TRANSFER]: '佣金金额可转赠',
  [ProfitTransferConfigEnum.CHANNEL_AMOUNT_TRANSFER]: '渠道收益可转赠',
  [ProfitTransferConfigEnum.CHARGING_AMOUNT_TRANSFER]: '充电收益可转赠',
  [ProfitTransferConfigEnum.MERCHANT_AMOUNT_TRANSFER]: '经销商销售收益可转赠',
};

/** 可提现类型多选选项（表单用，value 为字段名） */
export const withdrawTypeCheckboxOptions = [
  { label: '佣金金额', value: ProfitWithdrawConfigEnum.AMOUNT_WITHDRAW },
  { label: '充电收益', value: ProfitWithdrawConfigEnum.CHARGING_AMOUNT_WITHDRAW },
  { label: '经销商销售收益', value: ProfitWithdrawConfigEnum.MERCHANT_AMOUNT_WITHDRAW },
  { label: '渠道收益', value: ProfitWithdrawConfigEnum.CHANNEL_AMOUNT_WITHDRAW },
];

/** 可转赠类型多选选项（表单用，value 为字段名） */
export const transferTypeCheckboxOptions = [
  { label: '佣金金额', value: ProfitTransferConfigEnum.AMOUNT_TRANSFER },
  { label: '充电收益', value: ProfitTransferConfigEnum.CHARGING_AMOUNT_TRANSFER },
  { label: '经销商销售收益', value: ProfitTransferConfigEnum.MERCHANT_AMOUNT_TRANSFER },
  { label: '渠道收益', value: ProfitTransferConfigEnum.CHANNEL_AMOUNT_TRANSFER },
];

// 流水收益分佣类型选项
const deviceFlowRewardTypeOptions = [
  {
    label: "通用模式",
    value: 0,
  },
  {
    label: "自定义模式",
    value: 1,
  },
  {
    label: "不分佣",
    value: 2,
  },
];

export const  formTab = [
  // {
  //   label: "用户业务ID",
  //   name: "userBusinessId",
  //   type: "input",
  // },
  {
    label: "账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "昵称",
    type: "input",
    name: "nickName",

  },

  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
    params: {
      defaultTimer: [
      ],
    },
  },
]

// 防抖函数
let searchTimer: NodeJS.Timeout | null = null;

export const modalFormTab = (userList?: any[], getUserList?: any) => [
  {
    label: "提转用户",
    name: "userId",
    type: "select",
    options: userList,
    labelCol: { span: 4, offset: 0 },
    wrapperCol: { span: 18, offset: 0 },
    params: {
      onSearch: (val: string) => {
        if (searchTimer) clearTimeout(searchTimer);
        searchTimer = setTimeout(() => { if (val.trim()) getUserList(val); }, 300);
      },
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "请输入用户账号搜索",
      notFoundContent: userList?.length === 0 ? "暂无数据" : "请输入关键字搜索",
      style: { width: "80%" },
    },
    width: "100%",
    rules: [{ required: true, message: "请选择用户账号" }],
  },
  {
    label: "可提现类型",
    type:'text',
  },
  {
    label: "",
    name: "withdrawKeys",
    type: "checkboxGroup",
    options: withdrawTypeCheckboxOptions,
    width: "100%",
    labelCol: { span: 24, offset: 0 },
    wrapperCol: { span: 24, offset: 0 },
  },
  {
    label: "可转赠类型",
    type:'text',
  },

  {
    label: "",
    name: "transferKeys",
    type: "checkboxGroup",
    options: transferTypeCheckboxOptions,
    width: "100%",
    labelCol: { span: 24, offset: 4 },
    wrapperCol: { span: 24, offset: 0 },
  },
  // {
  //   label: "备注",
  //   name: "remark",
  //   type: "textArea",
  //   labelCol: { span: 10, offset: 0 },
  //   width: "320px",
  // },
];


export const columns = ({
  setModalFormData,
  setOpen,
  deleteCommissionData,
  editCommissionData
}: {
  setModalFormData: any;
  setOpen: any;
  deleteCommissionData: any;
  editCommissionData: any;
}) => [
  {
    title: "用户ID",
    dataIndex: "userId",
    key: "userId",
  },

  {
    title: "昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "账号",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: '提现类型',
    align: 'center' as const,
    children: [
      { title: '佣金金额', dataIndex: ProfitWithdrawConfigEnum.AMOUNT_WITHDRAW, key: 'wd-amount', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '充电收益', dataIndex: ProfitWithdrawConfigEnum.CHARGING_AMOUNT_WITHDRAW, key: 'wd-charging', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '经销商销售', dataIndex: ProfitWithdrawConfigEnum.MERCHANT_AMOUNT_WITHDRAW, key: 'wd-merchant', width: 100, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '渠道收益', dataIndex: ProfitWithdrawConfigEnum.CHANNEL_AMOUNT_WITHDRAW, key: 'wd-channel', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
    ],
  },
  {
    title: '转赠类型',
    align: 'center' as const,
    children: [
      { title: '佣金金额', dataIndex: ProfitTransferConfigEnum.AMOUNT_TRANSFER, key: 'tf-amount', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '充电收益', dataIndex: ProfitTransferConfigEnum.CHARGING_AMOUNT_TRANSFER, key: 'tf-charging', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '经销商销售', dataIndex: ProfitTransferConfigEnum.MERCHANT_AMOUNT_TRANSFER, key: 'tf-merchant', width: 100, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
      { title: '渠道收益', dataIndex: ProfitTransferConfigEnum.CHANNEL_AMOUNT_TRANSFER, key: 'tf-channel', width: 90, align: 'center' as const, render: (val: number | undefined) => { const isOpen = val === ProfitSwitchEnum.OPEN; return <span style={{ color: isOpen ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(val ?? ProfitSwitchEnum.CLOSE)}</span>; } },
    ],
  },


  // {
  //   title: "备注",
  //   dataIndex: "remark",
  //   key: "remark",
  // },

  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    render: (val: string) => {
      return <div>{getTimeFormat(val)}</div>
    }
  },
  // {
  //   title: "更新时间",
  //   dataIndex: "updateTime",
  //   key: "updateTime",
  // },
  {
    title: "操作",
    dataIndex: "id",
    key: "operation",
    fixed: "right",
    width: "120px",
    render: (val: string, rows: any) => (
      <Space>
        <Button
          size="small"
          icon={setIcons("EditOutlined")}
          type="text"
          onClick={(e) => {
            editCommissionData(rows);
          }}
        >
          修改
        </Button>
        <Button
          size="small"
          icon={setIcons("DeleteOutlined")}
          type="text"
          onClick={(e) => {
            deleteCommissionData(rows.id);
          }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];


